const audioTypes = [
  'audio/mpeg',
  'audio/wav',
  'audio/x-wav',
  'audio/vnd.wave',
  'audio/wave',
  'audio/flac',
  'audio/x-m4a',
];

const defaultValueState = {
  name: '',
  furiganaName: '',
  englishName: '',
  musicianName: '',
  musicianFuriganaName: null,
  musicianEnglishName: '',
  composerName: '',
  composerFuriganaName: null,
  composerEnglishName: '',
  arrangerName: '',
  arrangerFuriganaName: null,
  arrangerEnglishName: '',
  showTime: '',
  isrcCode: '',
  jasracCode: '',
  otherJasracCode: '',
  informationFee: '',
  lyricInformationFee: '',
};

const initSongsDefault = {
  arrangerEnglishName: '',
  arrangerFuriganaName: '',
  arrangerName: '',
  authorizedGroup: '',
  authorizedGroupType: null,
  collectCode: null,
  composerEnglishName: '',
  composerFuriganaName: '',
  composerName: '',
  englishName: '',
  furiganaName: '',
  id: null,
  index: '',
  informationFee: '',
  isrcCode: '',
  ivtType: null,
  jasracCode: '',
  liveType: null,
  lyricsClassifyType: null,
  musicianEnglishName: '',
  musicianFuriganaName: '',
  musicianName: '',
  name: '',
  otherJasracCode: '',
  showTime: '',
  sourceAudioUrl: '',
  versionIdentificationType: null,
  fileName: '',
  lyricInformationFee: '',
  riajGenreId: null,
  lyrics: '',
  sourceAudioUrlPreview: '',
};
const formListSongDefault = [initSongsDefault];

const MusicFormat = {
  MP3: 0,
  WAV: 1,
};

const MaxLength = {
  musicianName: 302,
  musicianEnglishName: 302,
  musicianFuriganaName: 452,
  composerName: 302,
  composerFuriganaName: 452,
  composerEnglishName: 302,
  arrangerName: 302,
  arrangerFuriganaName: 452,
  arrangerEnglishName: 302,
};

const AuthorizedGroupType = {
  JASRAC: 1,
  NexTone: 2,
  SelfManagement: 3,
  Other: 4,
};

export {
  audioTypes,
  defaultValueState,
  formListSongDefault,
  MusicFormat,
  MaxLength,
  initSongsDefault,
  AuthorizedGroupType,
};
